module.exports = __webpack_public_path__ + "media/images/chevron-right-8d00b2a061d3a3c752fce702626d8ba8.svg";